import { Component, inject, input, OnInit, output } from '@angular/core';

import { filter } from 'rxjs/operators';

import { ContentService } from './../../../../shared/content/content.service';
import { State, StateSelectOption } from './model';

@Component({
    selector: 'vision2-state-selector',
    templateUrl: './state-selector.component.html',
    styleUrls: ['./state-selector.component.scss'],
    standalone: false,
})
export class StateSelectorComponent implements OnInit {
    selectedStateChange = output<StateSelectOption>();

    customError = input<string>('');
    label = input<string>('');
    required = input<boolean>(false);
    errorIconImageUrl = input<string>('');

    states: StateSelectOption[];

    private contentService = inject(ContentService);

    ngOnInit(): void {
        this.setStates();
    }

    setStates(): void {
        this.contentService
            .getComponent('contact-us-state-selector')
            .pipe(filter((items) => !!items))
            .subscribe((items: State[]) => {
                this.states = this.flattenStates(items);
            });
    }

    flattenStates(states: State[]): StateSelectOption[] {
        const array = [];
        for (const state in states) {
            if (states.hasOwnProperty(state)) {
                const stateObj = {
                    value: states[state]['stateprovince-name'],
                };
                array.push(stateObj);
            }
        }

        return array.sort(function (a, b) {
            if (a.value < b.value) {
                return -1;
            }
            if (a.value > b.value) {
                return 1;
            }
            return 0;
        });
    }

    onBrandSelectChange(event: StateSelectOption): void {
        this.selectedStateChange.emit(event);
    }
}
